import { render, staticRenderFns } from "./IconTruckFast.vue?vue&type=template&id=14b68d38&"
import script from "./IconTruckFast.vue?vue&type=script&lang=ts&"
export * from "./IconTruckFast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports